var map = {
	"./Banner.webp": 6007,
	"./BannerFull.webp": 9310,
	"./CommunicationBanner.webp": 985,
	"./HomepageHeroMockupDesktop.webp": 9454,
	"./HomepageHeroMockupMobile.webp": 3452,
	"./Laptop.webp": 3369,
	"./PostPlaceholder.webp": 4372,
	"./Successors-view.webp": 3536,
	"./YourInvestitionsBackground.svg": 7607,
	"./man_climbing_stairs_heaven_1.webp": 3132,
	"./man_climbing_stairs_heaven_mobile.webp": 7519
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;